var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-list d-flex flex-wrap"},_vm._l((_vm.list),function(item,key){return _c('div',{key:key,staticClass:"card-wrap my-3"},[_c(_vm.cardType,{tag:"component",attrs:{"listItem":item,"listKey":key,"singleActions":_vm.singleActions,"cardFields":_vm.cardFields,"layoutDirection":_vm.layoutDirection}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }